import { emitProfileEditedBIEvent } from '../../services/bi-event';
import { WidgetEvent } from '../../services/data-sync-service';
import type InitialDataFetchService from '../../services/initial-data-fetch-service';
import type {
  PartialUpdatableFields,
  ProfileChangePayload,
  StoreState,
  ThunkDispatch,
  ThunkExtra,
} from '../../types';
import { getShowToastAction, getToggleIsSavingProfileAction } from '../actions';
import type { SetShowToastPayload } from '../slices/ui-slice';

export const toggleIsProfileSaving = (
  dispatch: ThunkDispatch,
  { dataSyncService }: ThunkExtra,
) => {
  const action = getToggleIsSavingProfileAction();

  dispatch(action);
  dataSyncService.emitEvent(action);
};

export const scheduleViewedMemberSync = ({ dataSyncService }: ThunkExtra) => {
  dataSyncService.scheduleEvent(WidgetEvent.SetViewedMember);
};

export const emitProfileEditBIEvents = (
  state: StoreState,
  updatedFields: PartialUpdatableFields,
  extra: ThunkExtra,
) => {
  emitProfileEditedBIEvent(state, updatedFields, extra);
};

export const showToast = (
  dispatch: ThunkDispatch,
  payload: SetShowToastPayload,
) => {
  dispatch(getShowToastAction(payload));
};

export const clearInitialDataCache = (
  state: StoreState,
  initialDataFetchService: InitialDataFetchService,
) => {
  const { current, viewed } = state.users;
  const currentMemberId = current?.uid ?? null;

  initialDataFetchService.clearCache(currentMemberId, viewed?.uid ?? null);
  initialDataFetchService.clearCache(currentMemberId, currentMemberId);
};

export const notifyProfileChangeObservers = (
  { profileSubject }: ThunkExtra,
  event: ProfileChangePayload,
) => {
  if (profileSubject) {
    profileSubject.notifyObservers(event);
  }
};
